import { useNavigate } from 'react-router-dom';
import milepadLogo from '../../assets/DasboardIcons/pad.png';

const Logo = ({ isMobile }) => {
    const navigate = useNavigate();

    return (
        <div aria-hidden={false} style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img
                alt="milepad-logo"
                src={milepadLogo}
            />
        </div>
    );
};

export default Logo;